/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardActivitySummary200,
  DashboardActivitySummaryParams,
  DashboardPlaylistStats200,
  DashboardSunoQueueStatus200,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 최근 N일간 플레이리스트 생성 활동을 날짜별로 집계합니다.
 * @summary 활동 요약 조회
 */
export const dashboardActivitySummary = (
  params?: DashboardActivitySummaryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DashboardActivitySummary200>(
    { url: `/api/dashboard/activity-summary/`, method: "GET", params, signal },
    options,
  );
};

export const getDashboardActivitySummaryQueryKey = (
  params?: DashboardActivitySummaryParams,
) => {
  return [
    `/api/dashboard/activity-summary/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDashboardActivitySummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardActivitySummary>>,
  TError = ErrorType<unknown>,
>(
  params?: DashboardActivitySummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardActivitySummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardActivitySummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardActivitySummary>>
  > = ({ signal }) => dashboardActivitySummary(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardActivitySummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DashboardActivitySummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardActivitySummary>>
>;
export type DashboardActivitySummaryQueryError = ErrorType<unknown>;

export function useDashboardActivitySummary<
  TData = Awaited<ReturnType<typeof dashboardActivitySummary>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | DashboardActivitySummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardActivitySummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardActivitySummary>>,
          TError,
          Awaited<ReturnType<typeof dashboardActivitySummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDashboardActivitySummary<
  TData = Awaited<ReturnType<typeof dashboardActivitySummary>>,
  TError = ErrorType<unknown>,
>(
  params?: DashboardActivitySummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardActivitySummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardActivitySummary>>,
          TError,
          Awaited<ReturnType<typeof dashboardActivitySummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDashboardActivitySummary<
  TData = Awaited<ReturnType<typeof dashboardActivitySummary>>,
  TError = ErrorType<unknown>,
>(
  params?: DashboardActivitySummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardActivitySummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 활동 요약 조회
 */

export function useDashboardActivitySummary<
  TData = Awaited<ReturnType<typeof dashboardActivitySummary>>,
  TError = ErrorType<unknown>,
>(
  params?: DashboardActivitySummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardActivitySummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDashboardActivitySummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 사용자의 플레이리스트를 상태별로 집계합니다.
 * @summary 플레이리스트 상태별 통계
 */
export const dashboardPlaylistStats = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DashboardPlaylistStats200>(
    { url: `/api/dashboard/playlist-stats/`, method: "GET", signal },
    options,
  );
};

export const getDashboardPlaylistStatsQueryKey = () => {
  return [`/api/dashboard/playlist-stats/`] as const;
};

export const getDashboardPlaylistStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPlaylistStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardPlaylistStats>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardPlaylistStatsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPlaylistStats>>
  > = ({ signal }) => dashboardPlaylistStats(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPlaylistStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DashboardPlaylistStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPlaylistStats>>
>;
export type DashboardPlaylistStatsQueryError = ErrorType<unknown>;

export function useDashboardPlaylistStats<
  TData = Awaited<ReturnType<typeof dashboardPlaylistStats>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlaylistStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlaylistStats>>,
          TError,
          Awaited<ReturnType<typeof dashboardPlaylistStats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDashboardPlaylistStats<
  TData = Awaited<ReturnType<typeof dashboardPlaylistStats>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlaylistStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPlaylistStats>>,
          TError,
          Awaited<ReturnType<typeof dashboardPlaylistStats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDashboardPlaylistStats<
  TData = Awaited<ReturnType<typeof dashboardPlaylistStats>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlaylistStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 플레이리스트 상태별 통계
 */

export function useDashboardPlaylistStats<
  TData = Awaited<ReturnType<typeof dashboardPlaylistStats>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPlaylistStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDashboardPlaylistStatsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 전역 Suno 음악 생성 큐의 진행/대기 곡 수와 예상 대기 시간을 반환합니다. 큐는 동시 최대 max_concurrent개씩 처리됩니다.
 * @summary Suno 음악 생성 큐 전역 상태
 */
export const dashboardSunoQueueStatus = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DashboardSunoQueueStatus200>(
    { url: `/api/dashboard/suno-queue-status/`, method: "GET", signal },
    options,
  );
};

export const getDashboardSunoQueueStatusQueryKey = () => {
  return [`/api/dashboard/suno-queue-status/`] as const;
};

export const getDashboardSunoQueueStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardSunoQueueStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof dashboardSunoQueueStatus>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardSunoQueueStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardSunoQueueStatus>>
  > = ({ signal }) => dashboardSunoQueueStatus(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardSunoQueueStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DashboardSunoQueueStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardSunoQueueStatus>>
>;
export type DashboardSunoQueueStatusQueryError = ErrorType<unknown>;

export function useDashboardSunoQueueStatus<
  TData = Awaited<ReturnType<typeof dashboardSunoQueueStatus>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardSunoQueueStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardSunoQueueStatus>>,
          TError,
          Awaited<ReturnType<typeof dashboardSunoQueueStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDashboardSunoQueueStatus<
  TData = Awaited<ReturnType<typeof dashboardSunoQueueStatus>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardSunoQueueStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardSunoQueueStatus>>,
          TError,
          Awaited<ReturnType<typeof dashboardSunoQueueStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDashboardSunoQueueStatus<
  TData = Awaited<ReturnType<typeof dashboardSunoQueueStatus>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardSunoQueueStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Suno 음악 생성 큐 전역 상태
 */

export function useDashboardSunoQueueStatus<
  TData = Awaited<ReturnType<typeof dashboardSunoQueueStatus>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardSunoQueueStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDashboardSunoQueueStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
